<script>
import appConfig from '@/app.config'
import { Helper } from '@/mixin/helper'
import moment from 'moment'
import { getSmsClient } from '@/services/sms'
import { GET_COMPANYS } from '@/services/api/master/companies'
import Multiselect from 'vue-multiselect'
import { formatIndexDate } from '@/helpers/tzDate'

const vsmsSmsAxios = getSmsClient()

export default {
  page: {
    title: 'Log History',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Multiselect,
  },
  apollo: {
    companies: {
      query: GET_COMPANYS,
    },
  },
  mixins: [Helper],
  mounted() {
    this.searchUsers()
  },
  data() {
    return {
      auditLogs: [],
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      filteredItems: [],
      companies: {
        companies: [],
      },
      companyId: null,
      userId: null,
      userLabel: null,
      rowPk: null,
      filter: null,
      tableName: null,
      tableOptions: [
        { label: 'Plat Nomer', value: 'vehicle' },
        { label: 'IMEI', value: 'device' },
        { label: 'Sensor', value: 'sensor' },
        { label: 'Configuration', value: 'vss_configuration' },
        { label: 'Fuel Calibration', value: 'vehicle_sensor_calibration' },
        //specific search by user
        { label: 'Pengubah', value: 'changer' },
      ],
      isDateRangeValid: true,
      filterByLabel: null,
      companyLabel: null,
      loading: false,
      filterValue: null,
      isDisableApplyBtn: false,

      searchTerm: '',
      loadingUsers: false,
      userSearchError: null,
      users: [],

      dateRange: [],
      maxDate: 1,
      pastDate: null,
      futureEnd: moment().add(24, 'hours'),
      isTimeChanged: false,
    }
  },
  computed: {
    title() {
      return 'Log History'
    },
    auditLog() {
      return [
        {
          key: 'time',
          label: this.$t('logHistory.auditLog.column.time'),
          sortable: true,
        },
        {
          key: 'table',
          label: 'Tabel',
          sortable: true,
        },
        {
          key: 'row_pk',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'company',
          label: this.$t('logHistory.company'),
          sortable: true,
        },
        {
          key: 'action',
          label: this.$t('logHistory.auditLog.column.action'),
          sortable: false,
        },
        {
          key: 'detail',
          label: this.$t('logHistory.auditLog.column.information'),
          sortable: false,
        },
        {
          key: 'user',
          label: this.$t('logHistory.auditLog.column.modifier'),
          sortable: true,
        },
      ]
    },
    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        let result = this.show_model.map((a) => a.key)

        return this.workOrder.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.auditLog
      }
    },
    shortcuts() {
      let startDay = new Date()
      startDay.setHours(0, 0, 0)

      let endDay = new Date()
      endDay.setHours(23, 59, 59)
      return [{ text: 'Hari Ini', onClick: () => [startDay, endDay] }]
    },
  },
  methods: {
    formatIndexDate,
    formatDetailWithLocalTime(detail) {
      const isoDatetimeRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/g
      return detail.replace(isoDatetimeRegex, (match) => {
        const formatIdxDate = formatIndexDate(match)
        return formatIdxDate.date + ' ' + formatIdxDate.time
      })
    },
    async searchUsers() {
      try {
        this.loadingUsers = true
        const response = await vsmsSmsAxios.get('/users/vsms')
        this.users = response.data.data
      } catch (error) {
        this.userSearchError = 'Failed to fetch users'
      } finally {
        this.loadingUsers = false
      }
    },
    applyFilter() {
      if (!this.dateRange[0] || !this.dateRange[1]) {
        this.isDateRangeValid = false
        return
      }

      this.isDateRangeValid = true
      this.getAuditLogs()
    },
    onTableSelect(selectedOption) {
      this.filterValue = null
      this.tableName = selectedOption ? selectedOption.value : null
    },
    onCompanySelect(selectedOption) {
      this.companyId = selectedOption ? selectedOption.id : null
    },
    onUserSelect(selectedOption) {
      this.userId = selectedOption ? selectedOption.userId : null
    },
    getCompanies() {
      return this.companies.companies
    },
    async getAuditLogs() {
      let fields = ''
      let query = ''

      this.loading = true
      this.isDisableApplyBtn = true
      this.currentPage = 1
      if (this.dateRange[0] === null) {
        return {
          data: [],
          page: 1,
          total_count: 0,
          total_pages: 0,
        }
      }
      const dateRange = [
        Helper.methods.momentYmDHmsPayload(this.dateRange[0], true),
        Helper.methods.momentYmDHmsPayload(this.dateRange[1], true),
      ]

      let filters = []

      filters.push('auditLog:tableName:in:vehicle|device|sensor|vss_configuration|vehicle_sensor_calibration')
      if (this.companyId) {
        filters.push(`auditLog:companyId:eq:${this.companyId}`)
      }

      if (this.tableName) {
        if (this.tableName == 'changer') {
          filters.push(`auditLog:editId:eq:${this.userId}`)
        } else {
          filters.push(`auditLog:tableName:eq:${this.tableName}`)
        }
      }

      if (this.filterValue) {
        filters.push(`auditLog:rowPk:ilike:${this.filterValue}`)
        fields = 'auditLog:data,new_data,rowPk'
        query = this.filterValue
      }

      let dragDate = new Date(dateRange[1])
      dragDate.setDate(dragDate.getDate() + 1)
      dateRange[1] = Helper.methods.momentYmDHmsPayload(dragDate, true)

      filters.push(`auditLog:editOn:gt:${dateRange[0]};auditLog:editOn:lte:${dateRange[1]}`)

      const filterStr = filters.join(';')

      let params = {
        page: this.currentPage,
        per_page: this.perPage,
        filters: filterStr,
        sorts: 'auditLog:editOn:desc',
        q: query,
        fields,
      }

      const response = await vsmsSmsAxios.get('/audit-log/vsms', { params })
      if (!response) {
        this.loading = false
        this.isDisableApplyBtn = false
        return
      }

      this.auditLogs = response.data.data
      this.filteredItems = response.data.data

      this.totalRows = response.data.total_count

      this.loading = false
      this.isDisableApplyBtn = false
      return response?.data
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.filteredItems = filteredItems
      this.currentPage = 1
    },
    pickDate(date) {
      let dateRange = this.dateRange

      if (!dateRange[0] && !dateRange[1]) {
        dateRange[0] = Helper.methods.momentYmDHms(date)
      } else if (!dateRange[1]) {
        dateRange[1] = Helper.methods.momentYmDHms(date)
      }

      this.pastDate = new Date(date.getTime() - 24 * this.maxDate * 3600 * 1000)
      this.futureEnd = moment().add(24, 'hours')
    },
    disabledDate: function (date) {
      let today = new Date()
      today.setHours(0, 0, 0, 0)
      return date > today
    },
    disabledTime: function (time) {
      if (this.dateRange.length === 0) return false
      let startRange = new Date(this.dateRange[0])
      const nextTimeDisabled = new Date(startRange.getTime() + 24 * 3600 * 1000)
      return time > nextTimeDisabled
    },
    handleOpenDatePicker(date) {
      if (date[0] === null && date[1] === null) {
        this.pastDate = null
        this.futureEnd = moment().add(24, 'hours')
      }
    },
    customLabel(item) {
      return `${item.name} (${item.domainName})`
    },
    customLabelEmployee(item) {
      return `${item.fullname}`
    },
  },
}
</script>
<style>
input.mx-input {
  font-size: small;
}
</style>
<template>
  <div>
    <div class="d-flex col-6 mb-5">
      <div class="pt-0 col-5">
        <label class="align-self-center fw-bold">
          {{ $t('logHistory.period') }} <span class="text-danger">*</span>
        </label>
        <date-picker
          v-model="dateRange"
          type="date"
          :placeholder="'Pilih Tanggal'"
          range
          :shortcuts="shortcuts"
          id="mc-datepicker-fuel"
          @pick="pickDate"
          :disabled-date="disabledDate"
          @change="handleOpenDatePicker"
          :class="{ 'border-danger': !isDateRangeValid }"
        ></date-picker>
        <div v-if="!isDateRangeValid" class="text-danger mt-2">Date is required</div>
      </div>

      <div class="pt-0 px-2 col-5">
        <label class="align-self-center fw-bold">{{ $t('logHistory.company') }}</label>
        <multiselect
          v-model="companyLabel"
          :options="companies.companies"
          placeholder="Pilih Company"
          :custom-label="customLabel"
          @input="onCompanySelect"
        ></multiselect>
      </div>

      <div class="pt-0 col-5">
        <label class="align-self-center fw-bold">Filter By</label>
        <multiselect
          v-model="filterByLabel"
          :options="tableOptions"
          placeholder="Filter By"
          label="label"
          @input="onTableSelect"
        ></multiselect>
      </div>

      <div class="pt-0 col-5 px-2">
        <label class="align-self-center fw-bold">Filter Value</label>
        <input
          v-if="tableName !== 'changer'"
          type="text"
          class="form-control"
          v-model="filterValue"
          placeholder="Filter Value"
        />

        <multiselect
          v-if="tableName == 'changer'"
          v-model="userLabel"
          :options="users"
          placeholder="Filter By"
          label="label"
          :custom-label="customLabelEmployee"
          @input="onUserSelect"
          :loading="loadingUsers"
          :internal-search="true"
        >
          <template #noResult>
            <div v-if="userSearchError" class="text-danger">{{ userSearchError }}</div>
            <div v-else>No users found. Start typing to search.</div>
          </template>
        </multiselect>
      </div>

      <div class="pt-0 col-5">
        <label class="align-self-center fw-bold text-white">F</label>
        <div>
          <button :disabled="isDisableApplyBtn" class="btn btn-primary ms-2" @click="applyFilter">
            {{ $t('global.search') }}
          </button>
        </div>
      </div>
    </div>

    <div class="table-responsive my-3 border border-1">
      <b-table
        class="datatables"
        :items="auditLogs"
        :fields="visibleFields"
        responsive="sm"
        show-empty
        :empty-text="$t('global.emptyTable')"
        :empty-filtered-text="$t('global.emptyFilteredTable')"
        :busy="loading"
        small
        empty-table
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template #cell(time)="data">
          {{ momentDMHms(data.value) }}
        </template>

        <template #cell(company)="data">
          {{ `${data.item.company.companyName} (${data.item.company.domainName})` }}
        </template>
        <template #cell(detail)="data">
          <span v-html="formatDetailWithLocalTime(data.value)"></span>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length" v-if="!loading">
          <label class="d-inline-flex align-items-center">
            <span>Menampilkan</span>
            <span>
              <b-form-select
                class="form-select form-select-sm"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              />
            </span>
            <span>entri.&nbsp;&nbsp;</span>
            <span
              >Menampilkan&nbsp;
              <strong>
                {{ (filteredItems?.length || 0) > 0 ? (currentPage - 1) * perPage + 1 : 0 }}
              </strong>
              &nbsp;sampai&nbsp;
              <strong>
                {{ Math.min(totalRows, currentPage * perPage) }}
              </strong>
              &nbsp;dari&nbsp;
              <strong>{{ totalRows }}</strong>
              &nbsp;entri.
            </span>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-if="!loading"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
